module.exports = {
	"name": "nav 配置文件",
	"desc": "因为不想用数据库故使用了 json 跟 yml",
	"keys": [
		"nav",
		"json",
		"yml"
	],
	"keyss": [
		"nav",
		"json",
		"yml"
	],
	"obj": {
		"a": "aa",
		"b": "bb"
	},
	"obj2": {
		"a": "aa",
		"b": "bb"
	},
	"list": [
		{
			"title": "Local",
			"list": [
				{
					"text": "Books",
					"link": "#/books"
				},
				{
					"text": "StyleExp",
					"link": "#/styleExamples/exp"
				},
				{
					"text": "expAnimate",
					"link": "#/vueExp/exp-animate"
				}
			]
		},
		{
			"title": "STAR",
			"list": [
				{
					"text": "云盘精灵",
					"link": "https://www.yunpanjingling.com/"
				},
				{
					"text": "otto",
					"link": "https://ot0.xyz/"
				}
			]
		},
		{
			"title": "GitBooks",
			"list": [
				{
					"text": "Tools Books One",
					"link": "https://ajimide.gitbooks.io/toolsbooksone/content"
				},
				{
					"text": "Tools Books Two",
					"link": "https://ajimide.gitbooks.io/toolsbookstwo/content"
				},
				{
					"text": "My JavaScript",
					"link": "https://ajimide.gitbooks.io/myjavascript/content"
				},
				{
					"text": "React Learn",
					"link": "https://ajimide.gitbooks.io/reactlearn/content/"
				}
			]
		},
		{
			"title": "Tools",
			"list": [
				{
					"text": "CanIUse",
					"link": "https://caniuse.com/"
				},
				{
					"text": null,
					"link": null
				}
			]
		},
		{
			"title": "Vue/React",
			"list": [
				{
					"text": "Vue home",
					"link": "https://cn.vuejs.org"
				},
				{
					"text": "Vue Cli3",
					"link": "https://cli.vuejs.org"
				},
				{
					"text": "Awesome-vue",
					"link": "https://github.com/vuejs/awesome-vue"
				},
				{
					"text": "React China",
					"block": true,
					"link": "https://react.docschina.org"
				},
				{
					"text": "React",
					"link": "https://reactjs.org"
				}
			]
		},
		{
			"title": "BingGo",
			"list": [
				{
					"text": "Css",
					"link": "#/css"
				}
			]
		},
		{
			"title": "Shopping",
			"list": [
				{
					"text": "网易严选",
					"link": "http://you.163.com"
				},
				{
					"text": "网易考拉",
					"link": "https://www.kaola.com"
				},
				{
					"text": "惠惠助手",
					"link": "http://www.huihui.cn"
				},
				{
					"text": "当当",
					"link": "http://www.dangdang.com"
				},
				{
					"text": "券妈妈",
					"link": "http://www.quanmama.com/"
				}
			]
		},
		{
			"title": "Design",
			"list": [
				{
					"text": "css-tricks",
					"link": "https://css-tricks.com"
				},
				{
					"text": "花瓣",
					"link": "https://huaban.com"
				},
				{
					"text": "Uisdc",
					"link": "https://www.uisdc.com/"
				},
				{
					"text": "iconfont",
					"link": "http://www.iconfont.cn"
				},
				{
					"text": "dribbble",
					"link": "https://dribbble.com/"
				}
			]
		},
		{
			"title": "二次元",
			"list": [
				{
					"text": "TapTap",
					"link": "https://www.taptap.com"
				},
				{
					"text": "酷安",
					"link": "https://www.coolapk.com"
				},
				{
					"text": "DxOMark",
					"link": "https://www.dxomark.com/cn"
				}
			]
		},
		{
			"title": "读书",
			"list": [
				{
					"text": "知乎",
					"link": "https://zhihu.com"
				},
				{
					"text": "酷安",
					"link": "https://www.coolapk.com"
				},
				{
					"text": "掘金",
					"link": "https://juejin.im"
				},
				{
					"text": "掘金酱",
					"link": "http://e.xitu.io"
				},
				{
					"text": "V2EX",
					"link": "https://v2ex.com"
				},
				{
					"text": "开源中国",
					"link": "https://www.oschina.net"
				},
				{
					"text": "segmentfault",
					"link": "https://segmentfault.com"
				},
				{
					"text": "Alloyteam",
					"link": "http://alloyteam.github.io"
				}
			]
		},
		{
			"title": "App",
			"list": [
				{
					"text": "Wox",
					"link": "https://github.com/Wox-launcher/Wox"
				},
				{
					"text": "TeamViewer",
					"link": "https://www.teamviewer.com/cn"
				},
				{
					"text": "小米快传",
					"link": null
				},
				{
					"text": "Cortana",
					"link": null
				},
				{
					"text": "REMOTE",
					"link": null
				},
				{
					"text": "AirDroid",
					"link": null
				}
			]
		},
		{
			"title": "科技",
			"list": []
		},
		{
			"title": "GitBooks",
			"list": []
		},
		{
			"title": "APP 设计",
			"list": [
				{
					"text": "24学堂",
					"link": "https://www.25xt.com"
				}
			]
		}
	]
};